import React, { Component } from 'react';
import { Carousel, CarouselItem, CarouselIndicators } from 'reactstrap';
import Css from './HorizontalSlider.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.animating = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.images !== this.props.images) {
      this.setState({ activeIndex: 0 });
    }
  }

  componentDidMount = () => {
    this.firstSlide = setTimeout(() => this.next(), 4000);
  };

  componentWillUnmount = () => {
    clearTimeout(this.firstSlide);
  };

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    clearTimeout(this.firstSlide);
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === this.props.images.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    clearTimeout(this.firstSlide);
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? this.props.images.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    clearTimeout(this.firstSlide);
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = this.props.images.map(item => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item}
        >
          <img src={item} alt={'Slider'} className={'img-fluid'} />
        </CarouselItem>
      );
    });

    return (
      <div>
        <Carousel
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
          interval={4000}
        >
          {slides}
          <div
            className={
              Css.navigation +
              ' d-flex align-items-center justify-content-center pointer ' +
              Css.left
            }
            onClick={this.previous}
          >
            <FontAwesomeIcon
              icon={['far', 'chevron-circle-left']}
              className={'pointer'}
            />
          </div>
          <div
            className={
              Css.navigation +
              ' d-flex align-items-center justify-content-center pointer ' +
              Css.right
            }
            onClick={this.next}
          >
            <FontAwesomeIcon
              icon={['far', 'chevron-circle-right']}
              className={'pointer'}
            />
          </div>
        </Carousel>
        <CarouselIndicators
          className={Css['carousel-indicator']}
          items={this.props.images.map(item => {
            return {
              key: item
            };
          })}
          activeIndex={activeIndex}
          onClickHandler={this.goToIndex}
        />
      </div>
    );
  }
}

export default Example;



// WEBPACK FOOTER //
// ./src/components/HorizontalSlider/HorizontalSlider.js